import { useState } from 'react';
import {
    endOfDay, startOfMonth, startOfQuarter, startOfYear
} from 'date-fns';

import RegularCustomersRange from './RegularCustomersRange';
import DashboardCard from '../components/DashboardCard';
import PeriodSelector from '../components/PeriodSelector';

import TabContext from '@mui/lab/TabContext';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Stack } from '@mui/material';
import DashboardOrdersExportButton from '../components/DashboardOrdersExportButton';

const RANGE_LABELS = {
    "1": "Mensual",
    "2": "Trimestral",
    "3": "Year to date"
};

const RANGE_OPTIONS = [
    { value: '1', label: 'Mensual' },
    { value: '2', label: 'Trimestral' },
    { value: '3', label: 'Year to date' }
];

const RegularCustomers = ({
    today,
    fqtMonthlyData, fqtQuarterlyData, fqtYearToDateData
}) => {
    const [value, setValue] = useState('3');
    const startDates = {
        '1': startOfMonth(today),
        '2': startOfQuarter(today),
        '3': startOfYear(today)
    };
    const year = today.getFullYear();
    
    return (
        <Box sx={{ mt: 6 }}>
            <TabContext value={value}>
                <DashboardCard
                    title={`Top 10 clientes frecuentes (${RANGE_LABELS[value]} - ${year})`}
                    action={
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <DashboardOrdersExportButton
                                reportType="frequent_customers"
                                range={{
                                    startDate: startDates[value],
                                    endDate: endOfDay(today)
                                }}
                                filename={`pedidos_clientes-frecuentes_${RANGE_LABELS[value].toLowerCase().replace(/\s+/g, '-')}_${year}.csv`}
                            />
                            <PeriodSelector
                                menuId="regular-customers-period-menu"
                                value={value}
                                options={RANGE_OPTIONS}
                                onChange={setValue}
                                icon={<MoreVertIcon />}
                                iconOnly
                                ariaLabel="Seleccionar periodo de clientes frecuentes"
                            />
                        </Stack>
                    }
                    contentSx={{ p: 0, '&:last-child': { pb: 0 } }}
                >
                    <RegularCustomersRange value="1" rows={fqtMonthlyData} />
                    <RegularCustomersRange value="2" rows={fqtQuarterlyData} />
                    <RegularCustomersRange value="3" rows={fqtYearToDateData} />
                </DashboardCard>
            </TabContext>
        </Box>
    );
};

export default RegularCustomers;
